import { MenuItem } from '@blueprintjs/core';
import { ItemRenderer, MultiSelect as MultiSelect2 } from '@blueprintjs/select';
import { ReactNode } from 'react';

export type IData = { disabled?: boolean } | unknown;

export interface IMultiSelectProps<T extends IData> {
  data: T[];
  values: T[];
  onSelect: (value: T) => void;
  onRemove: (tag: ReactNode, index: number) => void;
  onClear?: () => void;
  stringify: (value: T) => string;
  keyify?: (value: T) => string;
  className?: string | undefined;
  disabled?: boolean | undefined;
  fill?: boolean | undefined;
  placeholder?: string;
}

export function MultiSelect<T extends IData>({
  data,
  values,
  stringify,
  keyify,
  onSelect,
  onRemove,
  onClear,
  disabled,
  fill,
  placeholder,
}: IMultiSelectProps<T>) {
  const renderer: ItemRenderer<T> = (
    value,
    { handleClick, handleFocus, modifiers },
  ) => (
    <MenuItem
      text={stringify(value)}
      roleStructure="listoption"
      active={modifiers.active}
      key={(keyify ?? stringify)(value)}
      onClick={handleClick}
      onFocus={handleFocus}
      disabled={
        value !== null && typeof value === 'object' && 'disabled' in value
          ? value['disabled'] === true
          : undefined
      }
      selected={values.includes(value)}
    />
  );

  return (
    <MultiSelect2<T>
      placeholder={placeholder}
      itemPredicate={(query, item) => {
        return stringify(item).toLowerCase().includes(query.toLowerCase());
      }}
      resetOnSelect={true}
      noResults={<MenuItem disabled={true} text="No results." />}
      items={data ?? []}
      tagRenderer={stringify}
      tagInputProps={{
        onRemove: onRemove,
      }}
      itemRenderer={renderer}
      selectedItems={values}
      onItemSelect={onSelect}
      onClear={onClear}
      disabled={disabled}
      fill={fill}
    ></MultiSelect2>
  );
}
